// Task type constants
export const TaskTypes = {
  SWAP: "amount_swapped_of_token",
  DAILY_BUY: "daily_buy_token",
  HOLD_TOKEN: "hold_token",
  FOLLOW_TWITTER: "follow_twitter_account",
  RETWEET: "retweet_post",
  RETWEET_MVX: "retweet_twitter_post",
  JOIN_TELEGRAM: "join_telegram",
  CREATE_MEDIA: "create_media",
  JOIN_FILMIO: "join_film_community",
  JOIN_DISCORD: "join_discord",
  QUIZ: "quiz",
  CLICK_LINK: "click_link",
  TWITTER_USERNAME: "twitter_username",
  TWEET_KEYWORDS: "tweet_keywords",
  TOTAL_DELEGATION_TASK: "total_delegation_task",
  BALANCE_TOKEN: "balance_check",
  DAILY_CHECKIN: "daily_checkin",
  HOLD_NFT: "ape_wealth_snapshot",
  SHARE_PROGRESS: "share_progress",
  LIKE_POST: "like_post",
  DISCORD_REFERRAL: "discord_referral",
  TRADING: "trading",
  DISCORD_ROLE: "discord_role",
  SECRET_CODE: "secret_code",
  GOL_CHECK: "gol_check",
  RHUNA_QUERY: "rhuna_query",
  TWITTER_POST: "twitter_post",
  GOBLIN_QUERY: "goblin_query",
} as const;
